module.exports = __webpack_public_path__ + "static/media/gwp_10y_y-1.ce5217f6.csv";